import { render, staticRenderFns } from "./whatsapp-chat-content.vue?vue&type=template&id=2a6aebd0&scoped=true"
import script from "./whatsapp-chat-content.vue?vue&type=script&lang=js"
export * from "./whatsapp-chat-content.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-chat-content.vue?vue&type=style&index=0&id=2a6aebd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6aebd0",
  null
  
)

export default component.exports